import { render, staticRenderFns } from "./ToDoItem.vue?vue&type=template&id=964447ba&"
import script from "./ToDoItem.vue?vue&type=script&lang=js&"
export * from "./ToDoItem.vue?vue&type=script&lang=js&"
import style0 from "./ToDoItem.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

component.options.__file = "ToDoItem.vue"
export default component.exports